import Common from '../Common';
import Areacode from './Areacode';
import Webchat from './Webchat';
import Acl from './company/Acl';
import AdSync from './company/AdSync';
import Callback from './company/Callback';
import Cid from './company/Cid';
import CombiFetch from './company/CombiFetch';
import Creator from './company/Creator';
import CustomerData from './company/CustomerData';
import Department from './company/Department';
import Did from './company/Did';
import GenericRecording from './company/GenericRecording';
import Hotel from './company/Hotel';
import Integration from './company/Integration';
import Invoice from './company/Invoice';
import License from './company/License';
import Log from './company/Log';
import Message from './company/Message';
import Mobile from './company/Mobile';
import Omnigroup from './company/Omnigroup';
import Overview from './company/Overview';
import PBX from './company/PBX';
import Partner from './company/Partner';
import PbxDad from './company/PbxDad';
import PbxFlow from './company/PbxFlow';
import Profile from './company/Profile';
import PstnNumber from './company/PstnNumber';
import PstnRecording from './company/PstnRecording';
import QueueStat from './company/QueueStat';
import Queues from "./company/Queues";
import Recording from './company/Recording';
import Report from './company/Report';
import Retainment from './company/Retainment';
import SAML from './company/SAML';
import SMS from './company/SMS';
import SelfService from './company/SelfService';
import Server from './company/Server';
import SoundFile from './company/SoundFile';
import Template from './company/Template';
import User from './company/User';
import UserReports from './company/UserReports';
import Verify from './company/Verify';
import Wallboard from './company/Wallboard';
import WallboardOutgoing from './company/WallboardOutgoing';

interface Body {
	name: string
	pbx_tz_id: id
	pbx_country_id: id
	pbx_areacode_id: id
	ast_language_id: id
	description: string
}

const Company = class extends Common {
	selfservice: InstanceType<typeof SelfService>;
	license: InstanceType<typeof License>;
	user: InstanceType<typeof User>;
	pbx: InstanceType<typeof PBX>;
	customerData: InstanceType<typeof CustomerData>;
	queues: InstanceType<typeof Queues>;
	soundFile: InstanceType<typeof SoundFile>;
	wallboard: InstanceType<typeof Wallboard>;
	report: InstanceType<typeof Report>;
	queueStat: InstanceType<typeof QueueStat>;
	template: InstanceType<typeof Template>;
	department: InstanceType<typeof Department>;
	partner: InstanceType<typeof Partner>;
	log: InstanceType<typeof Log>;
	server: InstanceType<typeof Server>;
	acl: InstanceType<typeof Acl>;
	callback: InstanceType<typeof Callback>;
	invoice: InstanceType<typeof Invoice>;
	overview: InstanceType<typeof Overview>;
	cid: InstanceType<typeof Cid>;
	did: InstanceType<typeof Did>
	areacode: InstanceType<typeof Areacode>
	hotel: InstanceType<typeof Hotel>
	message: InstanceType<typeof Message>
	mobile: InstanceType<typeof Mobile>
	sms: InstanceType<typeof SMS>
	profile: InstanceType<typeof Profile>
	integration: InstanceType<typeof Integration>
	saml: InstanceType<typeof SAML>
	webchat: InstanceType<typeof Webchat>
	omnigroup: InstanceType<typeof Omnigroup>
	adSync: InstanceType<typeof AdSync>
	userReports: InstanceType<typeof UserReports>
	pbxFlow: InstanceType<typeof PbxFlow>
	pstnNumber: InstanceType<typeof PstnNumber>
	retainment: InstanceType<typeof Retainment>
	verify: InstanceType<typeof Verify>
	wallboardOutgoing: InstanceType<typeof WallboardOutgoing>
	recording: InstanceType<typeof Recording>
	genericRecording: InstanceType<typeof GenericRecording>
	pstnRecording: InstanceType<typeof PstnRecording>
	pbxDad: InstanceType<typeof PbxDad>
	combiFetch: InstanceType<typeof CombiFetch>
	creator: InstanceType<typeof Creator>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.selfservice = new SelfService(headers);
		this.license = new License(headers);
		this.user = new User(headers);
		this.pbx = new PBX(headers);
		this.customerData = new CustomerData(headers);
		this.queues = new Queues(headers)
		this.soundFile = new SoundFile(headers)
		this.wallboard = new Wallboard(headers)
		this.report = new Report(headers)
		this.queueStat = new QueueStat(headers)
		this.template = new Template(headers)
		this.department = new Department(headers)
		this.partner = new Partner(headers)
		this.log = new Log(headers)
		this.server = new Server(headers)
		this.acl = new Acl(headers)
		this.callback = new Callback(headers)
		this.invoice = new Invoice(headers)
		this.overview = new Overview(headers)
		this.cid = new Cid(headers)
		this.did = new Did(headers)
		this.areacode = new Areacode(headers)
		this.hotel = new Hotel(headers)
		this.message = new Message(headers)
		this.mobile = new Mobile(headers)
		this.sms = new SMS(headers)
		this.profile = new Profile(headers)
		this.integration = new Integration(headers)
		this.saml = new SAML(headers)
		this.webchat = new Webchat(headers)
		this.omnigroup = new Omnigroup(headers)
		this.adSync = new AdSync(headers)
		this.userReports = new UserReports(headers)
		this.pbxFlow = new PbxFlow(headers)
		this.pstnNumber = new PstnNumber(headers)
		this.retainment = new Retainment(headers)
		this.verify = new Verify(headers)
		this.wallboardOutgoing = new WallboardOutgoing(headers)
		this.recording = new Recording(headers)
		this.genericRecording = new GenericRecording(headers)
		this.pstnRecording = new PstnRecording(headers)
		this.pbxDad = new PbxDad(headers)
		this.combiFetch = new CombiFetch(headers)
		this.creator = new Creator(headers)
	}

	read = (companyId: id): CustomResponse<Company> =>
		this.get(`/company/${companyId}`)

	update = (companyId: id, body: Body) =>
		this.patch(`/company/${companyId}`, body)

	activate = (companyId: id) =>
		this.post(`/company/${companyId}/activate`)

	deactivate = (companyId: id) =>
		this.post(`/company/${companyId}/deactivate`)

	getDeleteQuestion = (companyId: id) =>
		this.get(`/company/${companyId}/getdeletequestion`)

	delete = (companyId: id, answer: string) =>
		this.doDelete(`/company/${companyId}/delete/${answer}`)

	deletable = (companyId: id): CustomResponse<CompanyDeletable> =>
		this.get(`/company/${companyId}/deletable`)

	getAllExtensFeatures = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/extensfeatures`)

	setDefaultDid = (companyId: id, didId: id) =>
		this.post(`/company/${companyId}/defaultdid/${didId}`)

	removeDefaultDid = (companyId: id) =>
		this.doDelete(`/company/${companyId}/defaultdid`)
}

export default Company
